import axios from "axios";
import * as Sentry from "@sentry/react";
import baseUrl from "../constants/baseUrl";

// forgot password action
// this action is called in forgot password page
export const forgotPassword =
  (email, setStatus, setError, setLoading) => async (dispatch) => {
    setError("");
    console.log("forgot pass cred", email);
    try {
      const { data } = await axios.get(
        `${baseUrl}Auth/forgotPassword?email=${email}`
      );
      console.log("forgot pass res data", data);
      setStatus("verify");
      if (setLoading) setLoading(false);
    } catch (error) {
      console.log(error);
      Sentry.captureException(error);
      setError("Something went wrong!");
      if (setLoading) setLoading(false);
    }
  };

// verify code action
// this action is called in forgotPassword page
export const verifyCodeAction =
  (email, code, setStatus, setError, setLoading) => async (dispatch) => {
    setError("");
    console.log("verify cred", email, code);
    try {
      const { data } = await axios.post(`${baseUrl}Auth/resetPasswordCode`, {
        email: email,
        code: code,
      });
      console.log("res from verify code action", data);
      setStatus("reset");
      if (setLoading) setLoading(false);
    } catch (error) {
      console.log(error);
      Sentry.captureException(error);
      setError("Something went wrong!");
      if (setLoading) setLoading(false);
    }
  };

// reset Password action
// this action is called in forgotPassword page
export const resetPassword =
  (email, password, history, setStatus, setError, setLoading) => async (dispatch) => {
    try {
      setError("");
      await axios.post(`${baseUrl}Auth/resetPassword`, {
        email,
        password,
      });
      history(`/Login`);
      setStatus(true);
      if (setLoading) setLoading(false);
    } catch (error) {
      console.log(error);
      Sentry.captureException(error);
      setError("Something went wrong!");
      if (setLoading) setLoading(false);
    }
  };
// reset Password action
// this action is called in reset password page
export const changePassword =
  (resetCreds, history, setStatus, setError, setLoading) => async (dispatch) => {
    try {
      setError("");
      await axios.post(`${baseUrl}Auth/changePassword`, resetCreds);
      console.log("response from change password API");
      // history(`/`);
      setStatus(true);
      if (setLoading) setLoading(false);
    } catch (error) {
      console.log(error);
      Sentry.captureException(error);
      setError("Something went wrong!");
      if (setLoading) setLoading(false);
    }
  };
